(() => {
  window.park.app({
    container: 'redirect-infobox',
    component: 'redirect-infobox',
  });
})();



// WEBPACK FOOTER //
// ./src/widgets/redirect-infobox/redirect-infobox.js